import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {luminaryOptions} from '../../lightProfileSectionConfig';

@customElement('page-luminare-all-available')
export class PageLuminareAllAvailable extends connect(store)(LitElement) {

	static styles = [
		css`
			.lampsSection {
				display: block;
			}

			.description p {
				font: var(--font-specsheet-print-light);
				color: #000;
				font-size: 1cqw;
				margin-bottom: 2cqw;
			}

			.lampsGrid {
				margin-top: 30px;
				display: flex;
				flex-wrap: wrap;
				gap: 2cqw;
			}

			.lampContainer {
				flex-basis: 30%;
			}

			.lampDescription {
				font: var(--font-specsheet-print-light);
				color: #000;
				font-size: 1cqw;
				margin-bottom: 2cqw;
			}

			.label {
				font: var(--font-specsheet-print-bold);
				font-size: 1cqw;
			}

			.imgContainer {
				border-bottom: 1px solid #C6C6C6;
				text-align: center;
				width: 100%;
			}

			.imgContainer img {
				margin: auto auto -4px;
				height: 15vw;
			}

		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lightProfile = state.lightProfile.data;
		this.lang = state.status.lang;
		this.luminaryElements = luminaryOptions.filter(luminary => luminary.availableForLightProfiles.includes(this.lightProfile.project.base));
	}

	render() {
		return html`
			<specsheet-light-section>
				<page-header content-title="${msg('Available luminaires')}"></page-header>
				<section class="lampsSection">
					<div class="lampsGrid">
						${repeat(this.luminaryElements, (luminary) => html`
							<div class="lampContainer">
								<div class="imgContainer"><img alt="Luminaire" src="${luminary.imageWhite}"/></div>
								<p class="lampDescription">
									<span class="label">${luminary.label[this.lang] || ''}</span>
									${luminary.description[this.lang] || ''}
								</p>
							</div>
						`)}
					</div>
				</section>
		`;
	}
}
